export default "__VITE_ASSET__US9XwRBo__"